<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Login Area -->
<section class="login-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="forgot-password-image">
                <img src="assets/img/forgot-password.jpeg" alt="image">
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="login-form">
                            <div class="logo">
                                <a routerLink="/"><img src="assets/img/black-logo.png" alt="image"></a>
                            </div>

                            <h3>Forgot Password</h3>

                            <p class="text-justify mt-3 mb-1">
                                Fill in your email address that you used to register, then click the submit button.We will send you a link to reset your password in your email Inbox or Spam.
                            </p>
                            

                            <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                                <div class="form-group">
                                    <input type="email" placeholder="{{emailText}}" class="form-control" formControlName="email">
                                    <div *ngIf="email.invalid && (email.dirty || email.touched)"
                                        class="alert alert-danger">

                                        <div *ngIf="email.errors.required">
                                            Email is required.
                                        </div>
                                        <div *ngIf="email.invalid && !email.errors.required">
                                            Invalid email.
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" class="mt-4" [ngClass]="{'disabled-button':forgotPasswordForm.invalid || isSendingOtp}" [disabled]="isSendingOtp">
                                    {{ isSendingOtp ? 'Sending OTP...' : submit }}
                                </button>
                            </form>

                            <div class="otp-modal-backdrop" *ngIf="showOtpDialog">
                                <div class="otp-modal-panel">
                                    <button type="button" class="otp-close-btn" (click)="resetOtpFlow()" aria-label="Close OTP modal">×</button>

                                    <div class="otp-badge" *ngIf="!otpVerified">OTP Verification</div>
                                    <div class="otp-badge success-badge" *ngIf="otpVerified">Reset Password</div>

                                    <ng-container *ngIf="!otpVerified">
                                        <h4>Enter the 4-digit code</h4>
                                        <p>We sent a security code to <strong>{{ resetEmail }}</strong></p>
                                        <input type="text" class="form-control otp-input" placeholder="1234"
                                            [value]="otpCode" (input)="otpCode = $any($event.target).value" maxlength="4">
                                        <button type="button" class="btn btn-success otp-verify-btn" (click)="verifyOtpCode()"
                                            [disabled]="isVerifyingOtp || otpCode.length !== 4">
                                            {{ isVerifyingOtp ? 'Verifying...' : 'Verify OTP' }}
                                        </button>
                                    </ng-container>

                                    <ng-container *ngIf="otpVerified">
                                        <h4>Set New Password</h4>
                                        <p>Choose a new password for your account.</p>

                                        <form [formGroup]="resetPasswordForm" (ngSubmit)="updatePassword()">
                                            <div class="form-group">
                                                <input type="password" class="form-control" placeholder="New Password" formControlName="password">
                                                <div *ngIf="password.invalid && (password.dirty || password.touched)" class="alert alert-danger">
                                                    <div *ngIf="password.errors.required">Password is required.</div>
                                                    <div *ngIf="password.errors.minlength">Password must be at least 6 characters long.</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <input type="password" class="form-control" placeholder="Confirm Password" formControlName="confirmPassword">
                                                <div *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)" class="alert alert-danger">
                                                    <div *ngIf="confirmPassword.errors.required">Confirm password is required.</div>
                                                    <div *ngIf="confirmPassword.errors.minlength">Password must be at least 6 characters long.</div>
                                                    <div *ngIf="confirmPassword.errors.mustMatch">Passwords must match.</div>
                                                </div>
                                            </div>

                                            <button type="submit" class="btn btn-primary otp-verify-btn" [disabled]="isUpdatingPassword || resetPasswordForm.invalid">
                                                {{ isUpdatingPassword ? 'Updating...' : 'Change Password' }}
                                            </button>
                                        </form>
                                    </ng-container>
                                </div>
                            </div>

        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Login Area -->